import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import { NewBackButton, SearchIcon } from "../../../components/svgs";
import { StyledText } from "../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../hooks";
import { Desktop } from "../../../containers/common";
import PlayTriviaModal from "./PlayTriviaModal";
import TriviaInfoModal from "./TriviInfoModal";
import { useLocation } from "react-router-dom";
import { RegionCitySelector } from "../../../components/common";

const RegionSelectionPage = () => {
  const { activeTrivia } = useTrivia();
  const [playTriviaModal, setPlayTriviaModal] = useState(false);
  const [triviInfoModal, setTriviaInfoModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const { themeContext, theme } = useTheme();

  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const location = useLocation();
  const { item } = location.state || {};

  const filteredRegions = regions.filter((region) =>
    region.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchInputFocus = () => {
    setIsFocused(true);
  };

  if (
    activeTrivia.rewardScheme === "online" &&
    !activeTrivia?.requireLocation
  ) {
    history.push("/trivia/location");
  }

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "70%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <BackButtonContainer
              onClick={() => {
                history.goBack();
              }}
              style={{ zIndex: 100, marginLeft: 20 }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <StyledText style={{ marginLeft: 20 }}>
              Select Your region
            </StyledText>
          </div>

          <DescriptionBody color={mashupBackground}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #C8CBCB",
                padding: 15,
                width: "80%",
                borderRadius: 15,
              }}
            >
              <input
                onFocus={handleSearchInputFocus}
                placeholder="Search for region"
                style={{
                  border: "none",
                  fontFamily: "MTNRegular",
                  outline: isFocused ? "none" : "none",
                }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              ></input>
              <SearchIcon fill="#797979" />
            </div>
            {filteredRegions.map((region, index) => (
              <div
                style={{
                  width: "80%",
                  backgroundColor: index === 0 ? background : "white",
                  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                  borderRadius: 8,
                  margin: 10,
                  paddingInline: 15,
                  overflow: "auto",
                  color: index === 0 ? "white" : "black",
                }}
                onClick={() =>
                  history.push("/trivia/location", {
                    item: region.cities,
                  })
                }
              >
                <StyledText>{region.label}</StyledText>
              </div>
            ))}
          </DescriptionBody>
        </Children>
      </MainHolder>
      {playTriviaModal && (
        <PlayTriviaModal onBackDropClick={() => setPlayTriviaModal(false)} />
      )}
      {triviInfoModal && (
        <TriviaInfoModal onBackButtonClick={() => setTriviaInfoModal(false)} />
      )}
    </>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;

// const SearchContainer = styled.div`
// display: "flex";
// justify-content: "space-between";
// border: "1px solid #C8CBCB";
// padding: 15px;
// width: 80%;
// border-radius: 15;
// `;
export default RegionSelectionPage;
export const regions = [
  {
    label: "Greater Accra Region",
    value: 0,
    cities: [
      { label: "Achimota", value: 0 },
      { label: "Adabraka", value: 31 },
      { label: "37 Shell", value: 1 },
      { label: "Accra Central", value: 2 },
      { label: "Accra Mall", value: 3 },
      { label: "Akweteyman", value: 4 },
      { label: "Airport", value: 30 },
      { label: "Ashaiman", value: 5 },
      { label: "Circle", value: 6 },
      { label: "Dansoman", value: 7 },
      { label: "Darkuman", value: 8 },
      { label: "East Legon", value: 9 },
      { label: "Haatso", value: 10 },
      { label: "Junction Mall", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy", value: 13 },
      { label: "Motorway Extension", value: 14 },
      { label: "NIA", value: 15 },
      // { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Tema 1", value: 19 },
      { label: "Tema 25", value: 20 },
      { label: "Tema 6", value: 21 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "Osu", value: 25 },
      { label: "Ridge", value: 26 },
      { label: "Newtown", value: 27 },
      { label: "Dzorwulu", value: 28 },
      { label: "Ada", value: 29 },
      { label: "Ajiringanor", value: 30 },
      { label: "Amrahia", value: 31 },
    ],
  },
  {
    label: "Ashanti Region",
    value: 1,
    cities: [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Otumfuo Park Dichemso", value: 15 },
      { label: "Bantama", value: 4 },
      { label: "Bibiani", value: 5 },
      { label: "Kejetia", value: 6 },
      { label: "KNUST", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Kumasi City Mall", value: 9 },
      { label: "Mampong", value: 10 },
      { label: "Nhyiaeso", value: 11 },
      { label: "Obuasi", value: 12 },
      { label: "Suame", value: 13 },
      { label: "Tafo", value: 14 },
    ],
  },
  {
    label: "Western Region",
    value: 2,
    cities: [
      { label: "Essiama", value: 0 },
      { label: "Takoradi Main", value: 1 },
      { label: "Takoradi Mall", value: 2 },
      { label: "Takoradi MC", value: 3 },
      { label: "Tarkwa", value: 4 },
      { label: "Bogoso", value: 5 },
    ],
  },
  {
    label: "Central Region",
    value: 3,
    cities: [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast University", value: 6 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
      { label: "Assin Fosu", value: 4 },
      { label: "Agona Swedru", value: 5 },
    ],
  },
  {
    label: "Eastern Region",
    value: 4,
    cities: [
      { label: "Atimpoku", value: 0 },
      { label: "Akropong", value: 11 },
      { label: "Donkorkrom", value: 1 },
      { label: "Koforidua", value: 2 },
      { label: "New Abirem", value: 3 },
      { label: "Asamankese", value: 4 },
      { label: "Akim Oda", value: 5 },
      { label: "Suhum", value: 6 },
      { label: "Nkawkaw", value: 7 },
      { label: "Osino", value: 8 },
      { label: "Nsawam", value: 9 },
      { label: "Somanya", value: 10 },
    ],
  },
  {
    label: "Bono Region",
    value: 5,
    cities: [
      { label: "Sunyani", value: 0 },
      { label: "Berekum", value: 1 },
      { label: "Dormaa", value: 2 },
    ],
  },
  {
    label: "Volta Region",
    value: 6,
    cities: [
      { label: "Ho", value: 0 },
      { label: "Aflao", value: 1 },
      { label: "Hohoe", value: 2 },
      { label: "Anlo", value: 3 },
      { label: "Anloga", value: 4 },
    ],
  },
  {
    label: "Northern Region",
    value: 7,
    cities: [
      { label: "Tamale Kaladan", value: 0 },
      { label: "Tamale", value: 1 },
      { label: "Bimbilla", value: 2 },
      { label: "Yendi", value: 3 },
    ],
  },
  {
    label: "Upper East Region",
    value: 8,
    cities: [
      { label: "Bolga", value: 0 },
      { label: "Bawku", value: 1 },
      { label: "Navrongo", value: 2 },
    ],
  },
  {
    label: "Upper West Region",
    value: 9,
    cities: [
      { label: "Wa", value: 0 },
      { label: "Lawra", value: 1 },
    ],
  },
  {
    label: "Bono East Region",
    value: 10,
    cities: [
      { label: "Techiman", value: 0 },
      { label: "Atebubu", value: 1 },
      { label: "Kintampo", value: 2 },
    ],
  },
  {
    label: "Western North Region",
    value: 11,
    cities: [
      { label: "Enchi", value: 0 },
      { label: "Sefwi Dwenase", value: 1 },
      { label: "Sefwi Juaboso", value: 2 },
    ],
  },
  {
    label: "Oti Region",
    value: 12,
    cities: [
      { label: "Nkwanta", value: 0 },
      { label: "Kete-Krachi", value: 1 },
    ],
  },
  { label: "Ahafo Region", value: 13, cities: [{ label: "Goaso", value: 0 }] },
];
